import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import Unlock from '@/images/Unlock.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { unlockElements } from '../../actions/Unlock';
import { StyledIconButton } from '../StyledIconButton';

export const UnlockItem = () => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        unlockElements(selectedElements);
    };

    return (
        <CustomTooltip title="Unlock" placement="top">
            <StyledIconButton ariaLabel="unlock" src={Unlock} onClick={handleClick} />
        </CustomTooltip>
    );
};
